import * as React from 'react';

export const showTruckRoutes = false;
export const showDepartingArrivingUnits = true;
export const showDepartingTrucks = true;
export const showCompanies = false;



// WEBPACK FOOTER //
// ./src/map/RoutesState.tsx